import { APP_PREFIX, FLOW_TYPE, COUNTRY } from '../../framework/App/AppConstants';
import { PAGE_NAME } from './GBConstants';
import NewCustomerPage from '../../GB/pages/NewCustomerPage/NewCustomerPage'; //todo promote this to shared page?
import ErrorPage from '../../GB/pages/ErrorPage/ErrorPage';
import ApplyPage from '../pages/ApplyPage/ApplyPage';
import CAPage from '../pages/CAPage/CAPage';
import IneligibilityPage from '../pages/IneligibilityPage/IneligibilityPage';
import DecisionPage from '../pages/DecisionPage/DecisionPage';
import ClosePage from '../../shared-components/ClosePage/ClosePage';
import CycoPage from '../pages/CycoPage/CycoPage';

const allFlows = `${APP_PREFIX}/(${FLOW_TYPE.DIRECT_APP}|${FLOW_TYPE.PROX}|${FLOW_TYPE.HERMES}|${FLOW_TYPE.TESLA}|${FLOW_TYPE.VENICE})/${COUNTRY.GREAT_BRITAIN}`;

const prodRoutes = [
    {
        path: `${APP_PREFIX}/(${FLOW_TYPE.DIRECT_APP}|${FLOW_TYPE.PROX}|${FLOW_TYPE.HERMES})/${COUNTRY.GREAT_BRITAIN}/${PAGE_NAME.NEWCUST_PAGE}`,
        component: NewCustomerPage
    },
    {
        path: `${allFlows}/${PAGE_NAME.APPLY_PAGE}`,
        component: ApplyPage
    },
    {
        path: `${allFlows}/${PAGE_NAME.CA_PAGE}`,
        component: CAPage
    },
    {
        path: `${allFlows}/${PAGE_NAME.ERROR_PAGE}`,
        component: ErrorPage
    },
    {
        path: `${allFlows}/${PAGE_NAME.INELIGIBLE_PAGE}`,
        component: IneligibilityPage
    },
    {
        path: `${allFlows}/${PAGE_NAME.DECISION_PAGE}`,
        component: DecisionPage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.VENICE}/${COUNTRY.GREAT_BRITAIN}/${PAGE_NAME.CLOSE_PAGE}`,
        component: ClosePage
    },
    {
        path: `${allFlows}/${PAGE_NAME.CYCO_PAGE}`,
        component: CycoPage
    }
];

const devRoutes = [];

export default () => {
    if (process.env.NODE_ENV !== 'production') {
        console.log('gb react - loading development routes'); // eslint-disable-line
        return [...prodRoutes, ...devRoutes];
    }

    return prodRoutes;
};
